module.exports = __webpack_public_path__ + "static/hero_patterns-5c3bc333c0dc28a1a212f4a111bca976.png";